import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { IconButton } from '@totalsoft/rocket-ui';
import { ArrowBack, ArrowUpward, FileCopyOutlined, FilterFramesOutlined } from '@mui/icons-material';

const HeaderLinks = ({ id, onClickClose, onDuplicate, onScoringTest, onNewVersion, disabled, canTestScoring }) => {
  const { t } = useTranslation();
  return (
    <>
      <IconButton fontSize='medium' color='transparent' tooltip={t('Tooltips.EngineScoringGrid.BackToList')} onClick={onClickClose}>
        <ArrowBack color='primary' />
      </IconButton>
      {id && (
        <>
          <IconButton fontSize='medium' color='transparent' tooltip={t('Tooltips.Duplicate')} onClick={onDuplicate}>
            <FileCopyOutlined color='primary' />
          </IconButton>
          {canTestScoring ? (
            <IconButton fontSize='medium' color='transparent' tooltip={t('Tooltips.Test')} onClick={() => onScoringTest(id)}>
              <FilterFramesOutlined color='primary' />
            </IconButton>
          ) : (
            <IconButton
              fontSize='medium'
              color='transparent'
              tooltip={t('EngineScoring.Test.Validations.InvalidEntityIdentifier')}
              disabled={true}
            >
              <FilterFramesOutlined />
            </IconButton>
          )}
          {!disabled && (
            <IconButton fontSize='medium' color='transparent' tooltip={t('Tooltips.NewVersion')} onClick={onNewVersion}>
              <ArrowUpward color='primary' />
            </IconButton>
          )}
        </>
      )}
    </>
  );
};

HeaderLinks.propTypes = {
  onClickClose: PropTypes.func.isRequired,
  id: PropTypes.number,
  onDuplicate: PropTypes.func.isRequired,
  onScoringTest: PropTypes.func.isRequired,
  onNewVersion: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  canTestScoring: PropTypes.bool
};

export default HeaderLinks;
